export default __webpack_public_path__ + "static/media/discord.a238d8c8.svg";